<template>
  <div class="flex flex-direction" id="developer">
    <div id="developer-pc">
      <div class="top">
        <Title :ch="'开发者社区'"></Title>
      </div>
      <div class="describe">
        <div class="ch">
          为开发者提供资源工具、学习成长、分享交流、生态实践等服务，帮助开发者快速成长。
        </div>
      </div>
      <div class="list flex justify-around">
        <div
          v-for="(item, index) in developerList"
          :key="index"
          class="list_box cs"
          :class="[
            index % 2 == 0 ? 'blueColor' : 'OddColor',
            hoverIndex === index ? 'hover' : '',
          ]"
          @mouseenter="hoverIndex = index"
          @click="
            hoverIndex = index;
            didClick_deve(item);
          "
        >
          <img v-if="hoverIndex === index" class="topImg" :src="topImgUrl" />
          <div class="list_box_top">
            <div
              class="tips self-start"
              :class="[index % 2 == 0 ? 'tips_color1' : 'tips_color2']"
            >
              {{ item.tag }}
            </div>
            <div
              class="box_title"
              :class="{ titleHover: hoverIndex == index }"
              v-html="titleFilter(item.title)"
            ></div>
          </div>
          <div class="list_box_foot">
            <div
              class="foot_con flex flex-direction justify-start"
              v-if="hoverIndex === index"
            >
              <div class="line self-justify-start"></div>
              <span> {{ item.con }}</span>
              <img />
            </div>
            <!--            <img-->
            <!--              class="defaultImg"-->
            <!--              :src="hoverIndex === index ? hoverImgUrl : item.bg"-->
            <!--            />-->
          </div>
        </div>
      </div>
      <!--      <div class="link flex align-center justify-center cs">-->
      <!--        <span-->
      <!--          class="text"-->
      <!--          @click="linkDownload('https://developer.huaweicloud.com/')"-->
      <!--        >-->
      <!--          查看更多 >></span-->
      <!--        >-->
      <!--      </div>-->
      <DidLink
        @click.native="linkDownload('https://developer.huaweicloud.com/')"
      ></DidLink>
    </div>
    <div id="developer-wap">
      <div class="top">
        <Title :ch="'开发者社区'" :bg-img="titleBgImg"></Title>
      </div>
      <div class="describe">
        为开发者提供资源工具、学习成长、分享交流、生态实践等服务，帮助开发者快速成长。
      </div>
      <div class="list flex">
        <div
          class="swiper-container1 flex justify-between"
          style="width: 100%; height: 100%"
        >
          <!--          <swiper-->
          <!--            :options="swiperOption"-->
          <!--            class="swiper-wrapper flex"-->
          <!--            style="width: 100%; height: calc(100% - 30px)"-->
          <!--          >-->
          <!--            <swiper-slide-->
          <!--              class="swiper-slide flex"-->
          <!--              style="-->
          <!--                width: 50%;-->
          <!--                height: 100%;-->
          <!--                transform: translate3d(0, 0, 0);-->
          <!--                overflow: hidden;-->
          <!--              "-->
          <!--              v-for="(developer, index) in developerList"-->
          <!--              :key="index"-->
          <!--            >-->
          <!--              <a-->
          <!--                @click="-->
          <!--                  toDetail({-->
          <!--                    url: developer.url,-->
          <!--                    title: developer.title,-->
          <!--                  })-->
          <!--                "-->
          <!--                v-if="isLowIos"-->
          <!--              >-->
          <!--                <div class="slide" style="width: 100%">-->
          <!--                  <div-->
          <!--                    class="tag flex align-center justify-center"-->
          <!--                    :class="[index % 2 == 0 ? 'colorl' : 'colorr']"-->
          <!--                  >-->
          <!--                    {{ developer.tag }}-->
          <!--                  </div>-->
          <!--                  <div class="desc" v-html="titleFilter(developer.title)"></div>-->
          <!--                  <img class="bgImg" :src="developer.bg_wap" />-->
          <!--                </div>-->
          <!--              </a>-->
          <!--              <div v-else class="slide" style="width: 100%">-->
          <!--                <div-->
          <!--                  class="tag flex align-center justify-center"-->
          <!--                  :class="[index % 2 == 0 ? 'colorl' : 'colorr']"-->
          <!--                >-->
          <!--                  {{ developer.tag }}-->
          <!--                </div>-->
          <!--                <div class="desc" v-html="titleFilter(developer.title)"></div>-->
          <!--                <img class="bgImg" :src="developer.bg_wap" />-->
          <!--              </div>-->
          <!--            </swiper-slide>-->
          <!--          </swiper>-->
          <div
            class="swiper-wrapper flex"
            style="width: 100%; height: calc(100% - 30px)"
          >
            <div
              class="swiper-slide flex"
              style="
                width: 50%;
                height: 100%;
                transform: translate3d(0, 0, 0);
                overflow: hidden;
              "
              v-for="(developer, index) in developerList"
              :key="index"
            >
              <div class="slide" style="width: 100%">
                <div
                  class="tag flex align-center justify-center"
                  :class="[index % 2 == 0 ? 'colorl' : 'colorr']"
                >
                  {{ developer.tag }}
                </div>
                <div class="desc" v-html="titleFilter(developer.title)"></div>
                <img class="bgImg" :src="developer.bg_wap" />
              </div>
            </div>
          </div>
          <div
            class="swiper-pagination1 flex align-center justify-center"
            slot="pagination"
            style="width: 100%; height: 20px"
          ></div>
        </div>
      </div>
      <DidLink
        @click.native="linkDownload('https://developer.huaweicloud.com/')"
      ></DidLink>
    </div>
  </div>
</template>

<script>
import Title from "./common/Title";
import "swiper/css/swiper.css";
// import { swiper, swiperSlide } from "vue-awesome-swiper";
import { Swiper } from "vue-awesome-swiper";
var self;
export default {
  name: "Developer",
  data() {
    return {
      isLowIos: false,
      swiperOption: {},
      alertL: "",
      titleBgImg: require("../assets/images/wap/title/developer.png"),
      selectImgUrl: require("../assets/images/developer/selectImg.png"),
      defaultImgUrl1: require("../assets/images/developer/rightArrow.png"),
      hoverImgUrl: require("../assets/images/developer/selectImg.png"),
      topImgUrl: require("../assets/images/developer/topImg.png"),
      developerList: [
        {
          title: "勇往直前，做全能开发者",
          con: "深度体验华为开发能力，挑战技术极限，闯关赢豪礼！",
          url: "https://developer.huaweicloud.com/activity/HPDC2022.html",
          tag: "活动",
          bg: require("../assets/images/developer/bg2.png"),
          bg_wap: require("../assets/images/wap/developer/bg4.png"),
        },
        {
          title: "抢先看：大咖齐聚 直播论道",
          con: "专家共话前沿趋势，解读鲲鹏、昇腾、鸿蒙等云计算新生态的技术创新和实践。",
          url: "https://bbs.huaweicloud.com/live/partner-developer2022_live/202204070900.html",
          tag: "直播",
          bg: require("../assets/images/developer/bg1.png"),
          bg_wap: require("../assets/images/wap/developer/bg2.png"),
        },
        {
          title: "技术检阅场 Ready？ Go！",
          con: "大会热点内容集结完毕，Pick您最感兴趣的华为开放能力，留下真知灼见。",
          url: "https://bbs.huaweicloud.com/forum/thread-179393-1-1.html",
          tag: "互动",
          bg: require("../assets/images/developer/bg4.png"),
          bg_wap: require("../assets/images/wap/developer/bg3.png"),
        },
        {
          title: "未来已来，2022技术探秘",
          con: "开发者关注的前沿技术热词盘点，华为云重磅开源技术全解析。",
          url: "https://bbs.huaweicloud.com/contents/partner-developer2022.html",
          tag: "内容",
          bg: require("../assets/images/developer/bg3.png"),
          bg_wap: require("../assets/images/wap/developer/bg1.png"),
        },
      ],
      hoverIndex: 0, //表示当前hover的是第几个li 初始为 -1 或 null 不能为0 0表示第一个li
      leftBg: require("../assets/images/wap/developer/leftBg.png"),
      rightBg: require("../assets/images/wap/developer/rightBg.png"),
      swiper_dev: null,
    };
  },
  components: {
    Title,
    // swiper,
    // swiperSlide,
  },
  created() {
    const userAgent = navigator.userAgent.toLowerCase();
    const versions = userAgent.match(/(\d+)(_\d+_\d+)/);
    const isIphone =
      userAgent.indexOf("iphone") > 0 || userAgent.indexOf("mac") > 0;
    let version = "";
    if (versions && versions[0]) {
      version = parseInt(versions[0].match(/\d+/)[0]);
    }
    if (isIphone && version < 13) {
      this.isLowIos = true;
    }

    const self = this;
    // self.swiperOption = {
    //   loop: true, //首尾循环
    //   centeredSlides: false,
    //   slidesPerView: 2, //每组 有多少块
    //   spaceBetween: 0, //板块间隔
    //   slidesPerGroup: 2, //多少个板块为1组。
    //   pagination: {
    //     el: ".swiper-pagination1",
    //     clickable: true,
    //     bulletClass: "my-bullet",
    //     bulletActiveClass: "my-bullet-active",
    //   },
    //   on: {
    //     click(e) {
    //       const realIndex = this.clickedSlide.getAttribute(
    //         "data-swiper-slide-index"
    //       );
    //       window._hw(
    //         "send",
    //         "action",
    //         "index_developer_community_theme_click",
    //         {
    //           content_name: self.developerList[realIndex].title, // 内容名称
    //           hw_relation: self.$store.state.userInfo.hwRelation, //与华为关系
    //         }
    //       );
    //       window.open(self.developerList[realIndex].url); // 新窗口打开外链接
    //     },
    //   },
    // };
  },
  mounted() {
    self = this;
    this.loadSwiper();
    this.$bus.$on("reSwiper", (res) => {
      //初始化 swiper 方法 ↓
      this.swiper_dev.init();
    });
  },
  methods: {
    titleFilter(val) {
      let text = val.replace(/([^，：\s]*[，：\s])(.*)/, "$1<br />$2");
      return `<span>${text}</span>`;
    },
    toDetail(option) {
      if (this.isLowIos) {
        this.didClick_deve(option);
      }
    },
    didClick_deve(option) {
      //埋码 开发者大会首页-点击社区专题
      //todo  拿个人中心的的数据 传 与为 关系
      window._hw("send", "action", "index_developer_community_theme_click", {
        content_name: option.title, // 内容名称
        product_tag: "", //产品标签
        industry_tag: "", //行业标签
        solution_tag: "", //解决方案标签
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
      });
      window.open(option.url); // 新窗口打开外链接
    },
    linkDownload(url) {
      //埋码
      // window._hw("send", "action", "index_cloud_developer_community_click", {});//进入华为云社区
      window._hw("send", "action", "index_developer_community_theme_click ", {
        module_name: "查看更多-华为云开发者社区",
      }); //开发者大会首页_点击查看更多+查看全部
      window.open(url); // 新窗口打开外链接
    },
    loadSwiper() {
      this.swiper_dev = new Swiper(".swiper-container1", {
        loop: true, //首尾循环
        centeredSlides: false,
        slidesPerView: 2, //每组 有多少块
        spaceBetween: 0, //板块间隔
        slidesPerGroup: 2, //多少个板块为1组。
        pagination: {
          el: ".swiper-pagination1",
          clickable: true,
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
        },
        on: {
          click(e) {
            const realIndex = this.clickedSlide.getAttribute(
              "data-swiper-slide-index"
            );
            window._hw(
              "send",
              "action",
              "index_developer_community_theme_click",
              {
                content_name: self.developerList[realIndex].title, // 内容名称
                hw_relation: self.$store.state.userInfo.hwRelation, //与华为关系
              }
            );
            window.open(self.developerList[realIndex].url); // 新窗口打开外链接
          },
        },
      });
    },
    destroySwiper() {
      this.swiper_dev.destroy(false); //移除所有slide监听事件，所以拖动和click事件失效了。
    },
  },
};
</script>

<style lang="scss" scoped>
#developer-pc {
  display: none;
}

#developer-wap {
  display: none;
}

@media screen and (max-width: 992px) {
  #developer-wap {
    display: block;
    width: 100%;
    padding-top: 143px;
    padding-bottom: 0px;
    .top {
      width: 100%;
    }
    .describe {
      margin: 0 auto;
      width: calc(100% - 70px);
      height: 83px;
      font-size: 24px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #151e26;
      line-height: 36px;
    }

    .list {
      margin: 0 auto;
      width: calc(100% - 70px);
      height: 510px;
      margin-top: 22px;
      overflow: hidden;

      ::v-deep .swiper-container1 {
        position: relative;

        .swiper-pagination1 {
          position: absolute;
          bottom: 0;
          left: 0;
        }

        .my-bullet {
          width: 26px;
          height: 8px;
          background: #c4c4c4;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          margin: 0 5px;
        }

        .my-bullet-active {
          background: #b4251e;
        }
      }

      .slide {
        width: 50%;
        height: 100%;
        box-sizing: border-box;
        padding: 64px 38px 0 42px;
        position: relative;
        transform: translate3d(0, 0, 0); //swiper ios闪屏解决办法
        .tag {
          width: 84px;
          height: 30px;
          border-radius: 0px 10px 0px 0px;
          font-size: 18px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;
          color: #ffffff;
          line-height: 18px;
        }

        .desc {
          width: 262px;
          height: 93px;
          margin-top: 22px;
          font-size: 30px;
          font-family: Microsoft YaHei-Light;
          font-weight: 600;
          color: #151e26;
          line-height: 45px;
        }

        .bgImg {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
        }

        .colorl {
          background-color: #f39c62;
        }

        .colorr {
          background-color: #b4251e;
        }
      }
    }
  }
}

@media screen and (min-width: 992px) {
  //developer begin
  #developer-pc {
    display: block;
    width: 100%;
    padding-top: 60px;
    padding-bottom: 60px;
    .top {
      width: 1600px;
      margin-left: 160px;
      .ch {
        width: 1158px;
        position: absolute;
        top: 10px;
        left: 0;
        font-size: $font-xxl;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
      }
    }

    .describe {
      width: 1600px;
      margin-left: 160px;
      margin-bottom: 28px;
      font-size: 18px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #333333;
    }
    .list {
      width: 1920px;

      .list_box {
        width: 480px;
        height: 520px;
        position: relative;

        &:nth-child(1) {
          background: url("../assets/images/developer/bg1.png");
          background-repeat: no-repeat;
          background-size: 520px 560px;
          background-position: -20px -20px;
        }
        &:nth-child(2) {
          background: url("../assets/images/developer/bg2.png");
          background-repeat: no-repeat;
          background-size: 520px 560px;
          background-position: -20px -20px;
        }
        &:nth-child(3) {
          background: url("../assets/images/developer/bg3.png");
          background-repeat: no-repeat;
          background-size: 520px 560px;
          background-position: -20px -20px;
        }
        &:nth-child(4) {
          background: url("../assets/images/developer/bg4.png");
          background-repeat: no-repeat;
          background-size: 520px 560px;
          background-position: -20px -20px;
        }
        &.hover {
          background: url("../assets/images/developer/selectImg.png");
          background-repeat: no-repeat;
          background-size: 405px 289px;
          background-position: bottom left;
        }

        .topImg {
          width: 100%;
          height: 10px;
          position: absolute;
          top: 0px;
          left: 0;
        }

        .list_box_top {
          width: 480px;
          padding-top: 70px;
          padding-left: 90px;

          .tips {
            width: 84px;
            height: 30px;
            margin-bottom: 20px;

            opacity: 1;
            font-size: $font-xl;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;
            color: #ffffff;
            line-height: 18px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            padding-left: 20px;
          }

          .tips_color1 {
            background: url("../assets/images/developer/title-orange.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: 0 0;
          }

          .tips_color2 {
            background: url("../assets/images/developer/title-red.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: 0 0;
          }

          .box_title {
            width: 335px;
            font-size: $font-xxxl;
            font-family: Microsoft YaHei-Light;
            font-weight: 600;
            color: #151e26;
            line-height: 46px;
          }

          .titleHover {
            color: #b4251e;
          }

          .con {
            width: 236px;
            height: 92px;
            font-size: $font-xxl;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;
            color: #666666;
            line-height: 24px;
          }
        }

        .list_box_foot {
          width: 478px;
          padding-left: 90px;

          .foot_con {
            width: 100%;
            height: 100%;

            .line {
              width: 53px;
              height: 4px;
              margin-top: 12px;
              margin-bottom: 22px;
              background: #b4251e;
              border-radius: 0 0 0 0;
              opacity: 1;
            }

            span {
              width: 302px;
              height: 92px;
              font-size: $font-xxl;
              font-family: Microsoft YaHei-Light;
              font-weight: 400;
              color: #151e26;
              line-height: 24px;
            }
          }

          .defaultImg {
            width: 500px;
            height: 537px;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
      }

      .blueColor {
        background: linear-gradient(
          146deg,
          #e2f4fe 0%,
          #ecf8ff 20%,
          #f5fbff 100%
        );
      }
      .OddColor {
        background: linear-gradient(
          146deg,
          rgba(255, 92, 92, 0.2) 0%,
          rgba(255, 92, 92, 0.1) 20%,
          rgba(255, 255, 255, 1) 100%
        );
      }

      .hoverBg {
        width: 295px;
        height: 380px;
        margin-top: -23px;
        background: linear-gradient(
          149deg,
          #bf4a68 0%,
          rgba(255, 255, 255, 0) 100%
        );
        box-shadow: 0 3px 4px 1px rgba(0, 0, 0, 0.03),
          inset -3px -3px 1px 1px rgba(255, 255, 255, 0.5);
        border-radius: 20px 20px 20px 20px;
        opacity: 0.5;
        border: 1px solid;
        border-image: linear-gradient(
            152deg,
            rgba(191, 74, 104, 0),
            rgba(191, 74, 104, 1)
          )
          1 1;
        filter: blur(undefinedpx);
      }
    }
  }
  //developer end
}
</style>
